/** Default and per-section SEO copy for ThinKaHa (slots, fishing, Shan Koe Mee, Bugyi, live casino, card games). */

/** Protocol + host (no trailing slash). Uses the live URL so one build works on ThinKaHa.biz, .cc, .tel, etc. */
export function getSiteOrigin() {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Absolute canonical URL for a route pathname (must match router SEO / index.html bootstrap).
 * @param {string} [path] pathname e.g. /home (query/hash ignored)
 */
export function getCanonicalUrlForPath(path) {
  const pathname = ((path || '/').split('?')[0] || '/').replace(/\/+$/, '') || '/';
  const origin = getSiteOrigin();
  if (!origin) return '';
  return pathname === '/' ? origin : `${origin}${pathname}`;
}

const BASE_DESC =
  'ThinKaHa offers online slots, fishing arcade games, Shan Koe Mee (Shan poker), Bugyi and classic card games, plus live casino with real dealers. Play securely, fast deposits and withdrawals, promotions for Myanmar players.';

const BASE_KEYWORDS =
  'ThinKaHa, online slots, slot games, fishing game, fishing arcade, Shan Koe Mee, Shan poker, ဘူဂျီ, Bugyi, Bugyee, online card games, live casino, live dealer, baccarat, roulette, Myanmar online casino, jackpot slots';

export const siteDefaults = {
  title: 'ThinKaHa | Online Slots, Fishing, Shan Koe Mee, Bugyi, Live Casino & Card Games',
  description: BASE_DESC,
  keywords: BASE_KEYWORDS,
};

export const pageMeta = {
  home: siteDefaults,

  slots: {
    title: 'Online Slot Games | ThinKaHa — Jackpots & Popular Slots',
    description:
      'Play hundreds of online slot games at ThinKaHa: classic reels, video slots, jackpots and bonus features. Fast play, fair results, mobile-friendly.',
    keywords: `${BASE_KEYWORDS}, video slots, jackpot slots, slot bonus`,
  },

  fishing: {
    title: 'Fishing Arcade Games Online | ThinKaHa',
    description:
      'Shoot-and-catch fishing arcade games at ThinKaHa. Colorful tables, multipliers and real-time action—popular in Myanmar and Southeast Asia.',
    keywords: `${BASE_KEYWORDS}, fishing shooter game, arcade fishing`,
  },

  liveCasino: {
    title: 'Live Casino & Live Dealer Games | ThinKaHa',
    description:
      'Live casino at ThinKaHa: real dealers, HD streams, baccarat, roulette and more. Feel like a real casino floor from your phone or desktop.',
    keywords: `${BASE_KEYWORDS}, live baccarat, live roulette, HD casino stream`,
  },

  shanKoeMee: {
    title: 'Shan Koe Mee Online Rooms | ThinKaHa',
    description:
      'Join Shan Koe Mee (Shan poker) tables at ThinKaHa. Play with friends or match online—authentic card rules and smooth gameplay.',
    keywords: `${BASE_KEYWORDS}, Shan Koe Mee room, Shan poker online`,
  },

  bugyee: {
    title: 'Bugyi (Bugyee) Card Game Online | ThinKaHa',
    description:
      'Play Bugyi / Bugyee card games online at ThinKaHa. Traditional Myanmar-style card play with reliable tables and quick rounds.',
    keywords: `${BASE_KEYWORDS}, Bugyi online, Bugyee card game`,
  },

  cardGames: {
    title: 'Online Card Games & Tables | ThinKaHa',
    description:
      'Card games and table games at ThinKaHa alongside slots and live casino. One account for multiple game types.',
    keywords: `${BASE_KEYWORDS}, table games, multiplayer cards`,
  },

  arcade: {
    title: 'Arcade & Casual Games | ThinKaHa',
    description: 'Arcade and casual games at ThinKaHa—quick fun between slots, fishing and live casino sessions.',
    keywords: `${BASE_KEYWORDS}, arcade games online`,
  },

  promotion: {
    title: 'Casino Promotions & Bonuses | ThinKaHa',
    description:
      'Latest ThinKaHa promotions: welcome offers, reload bonuses and cashback for slots, live casino and card games. Check terms on each offer.',
    keywords: `${BASE_KEYWORDS}, casino bonus, welcome bonus, cashback`,
  },

  login: {
    title: 'Member Login | ThinKaHa',
    description: 'Log in to your ThinKaHa account to play slots, fishing, Shan Koe Mee, Bugyi, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, ThinKaHa login`,
  },

  register: {
    title: 'Register & Join | ThinKaHa',
    description:
      'Create a ThinKaHa account in minutes. Access slots, fishing games, Shan Koe Mee, Bugyi, live casino and secure banking.',
    keywords: `${BASE_KEYWORDS}, ThinKaHa register, sign up`,
  },

  contact: {
    title: 'Contact Us | ThinKaHa',
    description: 'Contact ThinKaHa support for account, deposits, withdrawals and game questions.',
    keywords: `${BASE_KEYWORDS}, ThinKaHa support, customer service`,
  },

  rule: {
    title: 'Rules & Terms | ThinKaHa',
    description: 'Rules, terms and responsible play information for ThinKaHa members.',
    keywords: `${BASE_KEYWORDS}, terms and conditions`,
  },

  deposit: {
    title: 'Deposit | ThinKaHa',
    description: 'Deposit funds securely to play slots, fishing, live casino and card games at ThinKaHa.',
    keywords: `${BASE_KEYWORDS}, deposit`,
    robots: 'noindex, nofollow',
  },

  withdraw: {
    title: 'Withdraw | ThinKaHa',
    description: 'Withdraw your winnings from ThinKaHa with supported payment methods.',
    keywords: `${BASE_KEYWORDS}, withdraw`,
    robots: 'noindex, nofollow',
  },

  banking: {
    title: 'Banking | ThinKaHa',
    description: 'Banking and payment options for ThinKaHa members.',
    keywords: `${BASE_KEYWORDS}, banking`,
    robots: 'noindex, nofollow',
  },

  history: {
    title: 'Transaction History | ThinKaHa',
    description: 'View your ThinKaHa transaction history.',
    robots: 'noindex, nofollow',
  },

  setting: {
    title: 'Account Settings | ThinKaHa',
    description: 'Manage your ThinKaHa account settings.',
    robots: 'noindex, nofollow',
  },

  betslip: {
    title: 'Betslip History | ThinKaHa',
    description: 'Your betslip history at ThinKaHa.',
    robots: 'noindex, nofollow',
  },

  liveScore: {
    title: 'Live Score | ThinKaHa',
    description: 'Live scores and sports updates at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  matchResult: {
    title: 'Football Match Results | ThinKaHa',
    description: 'View today and yesterday football match results at ThinKaHa.',
    keywords: `${BASE_KEYWORDS}, football results, match results`,
  },

  maungFb: {
    title: 'Maung FB | ThinKaHa',
    description: 'Maung FB at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  bodyFb: {
    title: 'Body FB | ThinKaHa',
    description: 'Body FB at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  videoLinks: {
    title: 'Video Links | ThinKaHa',
    description: 'Video links and guides at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  commission: {
    title: 'Commission | ThinKaHa',
    description: 'Commission program at ThinKaHa.',
    robots: 'noindex, nofollow',
  },

  level: {
    title: 'VIP Levels | ThinKaHa',
    description: 'VIP levels and rewards at ThinKaHa.',
    keywords: `${BASE_KEYWORDS}, VIP`,
  },

  guides: {
    title: 'App Install Guide | ThinKaHa',
    description: 'Install the ThinKaHa app on Android or iOS for slots, fishing, live casino and card games.',
    keywords: `${BASE_KEYWORDS}, ThinKaHa app, install guide`,
  },

  androidGuide: {
    title: 'Android App Install | ThinKaHa — Slots, Fishing & Live Casino',
    description:
      'Install ThinKaHa on Android: play online slots, fishing games, Shan Koe Mee, Bugyi and live casino on your phone.',
    keywords: `${BASE_KEYWORDS}, ThinKaHa Android APK`,
  },

  iosGuide: {
    title: 'iOS App Install | ThinKaHa — Slots, Fishing & Live Casino',
    description:
      'Install ThinKaHa on iPhone or iPad: slots, fishing arcade, card games and live dealer casino.',
    keywords: `${BASE_KEYWORDS}, ThinKaHa iOS app`,
  },

  dreamBooks: {
    title: 'Dream Books | ThinKaHa',
    description: 'Dream books feature at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  twoD: {
    title: '2D | ThinKaHa',
    description: '2D games at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  threeD: {
    title: '3D | ThinKaHa',
    description: '3D games at ThinKaHa.',
    keywords: BASE_KEYWORDS,
  },

  landing: {
    title: 'ThinKaHa — Slots, Fishing, Live Casino & Card Games',
    description: BASE_DESC,
    keywords: BASE_KEYWORDS,
  },

  iframe: {
    title: 'Game | ThinKaHa',
    robots: 'noindex, nofollow',
  },

  verify: {
    title: 'Verify Account | ThinKaHa',
    robots: 'noindex, nofollow',
  },

  dataTable: {
    title: 'Data | ThinKaHa',
    robots: 'noindex, nofollow',
  },
};
